<pt-breadcrumbs
  class="border-b border-solid border-slate-300 bg-white"
  [breadcrumbs]="breadcrumbs$ | async"
/>

<div class="mx-auto my-8 flex max-w-6xl flex-col gap-4">
  @if (organisation$ | async; as organisation) {
    <div class="flex flex-row gap-4">
      <pr-organisation-selector
        [organisations]="organisations$ | async"
        [selectedOrganisation]="organisation"
        (organisationSelected)="setOrganisationSelected($event)"
      />
      <div class="flex grow"></div>
      <pr-organisation-status [status]="organisation.status" />
      <pr-organisation-actions [organisation]="organisation" />
    </div>
  }
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    @if (organisation$ | async; as organisation) {
      <div class="flex flex-col gap-4 rounded-md bg-white p-4 shadow-md">
        <h3 class="!m-0 !font-bold">Details</h3>
        <div>Slug: {{ organisation.slug }}</div>
        <div>Region: {{ organisation.region }}</div>
        <div>
          Joined:
          {{ organisation.createdAt | moment | amDateFormat: dateFormat }}
        </div>
      </div>
    }

    <div class="flex flex-col gap-4 rounded-md bg-white p-4 shadow-md">
      <h3 class="!m-0 !font-bold">Links</h3>
      <mat-nav-list>
        <a mat-list-item [routerLink]="['./users']">Users</a>
        <a mat-list-item [routerLink]="['./roles']">Roles</a>
      </mat-nav-list>
    </div>

    <div
      class="col-span-full flex flex-col gap-4 rounded-md bg-white p-4 shadow-md"
    >
      <div class="flex justify-between">
        <h3 class="!m-0 !font-bold">Stripe Subscription Details</h3>

        <button mat-stroked-button color="primary" (click)="addSubscription()">
          Add Subscription
        </button>
      </div>

      <table mat-table [dataSource]="subscriptions$ | async">
        <tr *matHeaderRowDef="subscriptionColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: subscriptionColumns" mat-row></tr>

        <ng-container matColumnDef="customerId">
          <th *matHeaderCellDef mat-header-cell>Customer Id</th>
          <td *matCellDef="let subscription" mat-cell>
            {{ subscription.customerId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="subscriptionId">
          <th *matHeaderCellDef mat-header-cell>Subscription Id</th>
          <td *matCellDef="let subscription" mat-cell>
            {{ subscription.subscriptionId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="practiceRef">
          <th *matHeaderCellDef mat-header-cell>Practice</th>
          <td *matCellDef="let subscription" mat-cell class="text-xs">
            @for (
              practiceRef of subscription.practiceRefs;
              track practiceRef.path
            ) {
              <div>{{ practiceRef | map: getPracticeName | async }}</div>
            } @empty {
              <div class="text-slate-500">Not Practice Specific</div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="meteredBillingEnabled">
          <th *matHeaderCellDef mat-header-cell>SMS Credits Enabled</th>
          <td *matCellDef="let subscription" mat-cell class="text-xs">
            @if (subscription.meteredBillingEnabled) {
              <div>Yes</div>
            } @else {
              <div>No</div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef mat-header-cell></th>
          <td *matCellDef="let subscription" mat-cell>
            <div class="flex justify-end gap-2">
              <button
                mat-stroked-button
                (click)="editSubscription(subscription)"
              >
                Edit
              </button>
              <button
                mat-stroked-button
                color="warn"
                (click)="deleteSubscription(subscription)"
              >
                Delete
              </button>
            </div>
          </td>
        </ng-container>
      </table>
    </div>

    <div
      class="col-span-full flex flex-col gap-4 rounded-md bg-white p-4 shadow-md"
    >
      <h3 class="!m-0 !font-bold">Settings</h3>
      <form class="flex flex-col gap-4" [formGroup]="form">
        <div>
          <mat-form-field class="!flex grow" floatLabel="always">
            <mat-label>Opt-In Features</mat-label>
            <mat-select multiple formControlName="optInFeatures">
              @for (feature of optInFeatures; track feature) {
                <mat-option [value]="feature">
                  {{ feature | splitKebab | titlecase }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>Enable features in preview for this workspace</mat-hint>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="!flex grow" floatLabel="always">
            <mat-label>Account Managers</mat-label>
            <mat-select
              multiple
              formControlName="accountManagers"
              [compareWith]="compareStafferRefs"
            >
              @for (staffer of managementStaff$ | async; track staffer.ref.id) {
                <mat-option [value]="staffer.ref">
                  {{ staffer.user.name }}
                </mat-option>
              }
            </mat-select>
            <mat-hint>
              Management staff assigned as account owners for this workspace
            </mat-hint>
          </mat-form-field>
        </div>
        <div class="flex justify-end">
          <button
            mat-flat-button
            color="primary"
            [disabled]="isDisabled$ | async"
            (click)="save()"
          >
            Save
          </button>
        </div>
      </form>
    </div>
    <div
      class="col-span-full flex flex-col gap-4 rounded-md bg-white p-4 shadow-md"
    >
      <h3 class="!m-0 !font-bold">Integrations</h3>
      <pr-manage-sms-integration
        [organisation]="organisation$ | async"
        [integrationsCol]="integrationsColRef$ | async"
        [temporaryTokensCol]="temporaryTokensColRef$ | async"
      />
    </div>
  </div>
</div>
